/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginAliases {
  BUTTON_NOVO_USUARIO = 'button-novo-usuario',
  LAYOUT_0 = 'layout-0',
  LAYOUT_LOGIN = 'layout-login',
  LOGIN = 'login',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  SOCIAL_NETWORKS = 'social-networks',
  TEXT_ENDERECO = 'text-endereco',
  TEXT_FONE = 'text-fone',
  TEXT_MAIL = 'text-mail',
}
export { LoginAliases };
